import {computed} from '@api'
import {VipLocalStore} from '@modules'
import {GroupByPageIndividualStore, GroupByPagesStore, IGroupsPerPage} from '@modules/pdf'
import {StoresInstance} from '@stores'

export class GroupByRowPageStore extends VipLocalStore {
  constructor(stores: StoresInstance, public groupByPagesStore: GroupByPagesStore) {super(stores)}

  private get size() {
    return this.groupByPagesStore.size
  }

  private get layout() {
    return this.groupByPagesStore.layout
  }

  private get groups() {
    return this.groupByPagesStore.groups
  }

  private get rowsPerPage() {
    return this.groupByPagesStore.rowsPerPage
  }

  @computed get noOfGroups() {
    const {groupBy: {hierarchyGroups}} = this
    return hierarchyGroups.length
  }

  @computed get itemsPerRow() {
    const {pdf: {itemsPerRow}} = this
    return itemsPerRow
  }

  @computed get grouping() {
    const {pdf: {grouping}} = this
    return grouping
  }

  private get maxLimit() {
    return this.groupByPagesStore.maxLimit
  }

  @computed get pages() {
    const {catalog, groupsPerPage, groups} = this
    if (!groups?.length) return []
    return groupsPerPage.map(({pageIndex, data, group}) => {
      const store = new GroupByPageIndividualStore(catalog.stores, {data, pageIndex, group})
      return store.page
    })
  }

  @computed
  private get groupsPerPage(): Array<IGroupsPerPage> {
    const {groups, rowsPerPage, size, maxLimit, noOfGroups, itemsPerRow} = this,
      pages = []
    let pageIndex = 1,
      totalItems
    (groups ?? []).forEach((group) => {
      if (totalItems === undefined) {totalItems = 0}
      if (totalItems < maxLimit) {
        const {items: {items}} = group,
          len = items.length
        let page: IGroupsPerPage = _.last(pages) ?? {pageIndex, data: [], group: []},
          remainingQueryLimit = len < maxLimit ? len : maxLimit,
          splice = remainingQueryLimit < size ? remainingQueryLimit : size,
          noOfPagesForGroup = Math.ceil(items.length / (rowsPerPage * itemsPerRow))

        const noOfRows = items.length < size ? 1 : Math.ceil((items.length + noOfPagesForGroup) / size)
        _.range(0, noOfRows).forEach(r => {
          const isFirst = (r === 0 || page.group.length === 0) && noOfGroups > 1,
            d = items.splice(0, (isFirst && (items.length > size - 1) ? splice - 1 : splice))
          page.data.push(isFirst ? [...(group.spec ?? {}), ...d] : d)
          page.group.push(group)
          totalItems += d.length
          if (page.data.length === rowsPerPage) {
            page.complete = true
            if (!pages.some(p => p.pageIndex === pageIndex)) pages.push(page)
            pageIndex++
            page = {pageIndex, data: [], group: []}
          }
        })
        if (!pages.some(p => p.pageIndex === pageIndex)) pages.push(page)
      }
    })

    return pages.filter(p => p.data.length)
  }

}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/GroupByRowPageStore.ts